import { addDataLayerListener, openAnalyticsDebug, autowireAnalytics } from './automated-analytics';

const
    SELECTOR_TRIGGER = "data-layer-trigger",
    STORAGE_KEY_PLATFORM = "soulframe-platform",
    triggers = [ ... document.querySelectorAll( `[ ${ SELECTOR_TRIGGER } ]` ) ];

window.app = window.app || {};
window.app.data = window.app.data || {};
window.dataLayer = window.dataLayer || [];
window.openAnalyticsDebug = openAnalyticsDebug;

function dataLayerEvents () {

    // update `window.app.data` with initial page load information

    // Regular SELECTOR_TRIGGER elements
    triggers.forEach( ( element, index ) => {
        // console.log( `Trigger ${ index } found!`,{ element, "trigger action": element.getAttribute( SELECTOR_TRIGGER ) } );

        let token = element.getAttribute( SELECTOR_TRIGGER );

        switch( token.toLowerCase() ){
            case "click-root":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'sitenav_click',
                        creative_placement: 'sitenav-root',
                        creative_title: 'logo',
                        creative_type: 'sitenav',
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "click-home":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'sitenav_click',
                        creative_placement: 'sitenav-root',
                        creative_title: 'home',
                        creative_type: 'sitenav',
                        destination_url: element.getAttribute('href'),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "click-news":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'sitenav_click',
                        creative_placement: 'sitenav-root',
                        creative_title: 'news',
                        creative_type: 'sitenav',
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "click-store":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'sitenav_click',
                        creative_placement: 'sitenav-root',
                        creative_title: 'store',
                        creative_type: 'sitenav',
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "click-media":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'sitenav_click',
                        creative_placement: 'sitenav-root',
                        creative_title: 'media',
                        creative_type: 'sitenav',
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "click-signup":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'button_click',
                        creative_placement: 'sitenav-root',
                        creative_title: 'signup',
                        creative_type: 'button',
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "click-promo-codes":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'button_click',
                        creative_placement: 'sitenav-root',
                        creative_title: 'redeem',
                        creative_type: 'button',
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "home-cta-reserve":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'button_click',
                        creative_placement: 'masthead',
                        creative_title: 'signup',
                        creative_type: 'button',
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "home-cta-redeem":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'button_click',
                        creative_placement: 'masthead',
                        creative_title: 'redeem',
                        creative_type: 'button',
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "home-cta-trailer":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'button_click',
                        creative_placement: 'masthead',
                        creative_title: 'watch-trailer',
                        creative_type: 'button',
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "news-showcase-card":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'newsfeed_click',
                        creative_placement: 'news',
                        creative_type: 'newsfeed',
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "home-news-showcase-more":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'button_click',
                        creative_placement: 'news',
                        creative_title: 'more-news',
                        creative_type: 'button',
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "sf_signup":
                //console.log("sf_signup");
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'signup_form_submission_initiated',
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "social-click":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'social_click',
                        creative_placement: 'global-footer',
                        creative_type: 'social',
                        creative_title: element.textContent.toLowerCase(),
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "confirmation-success":
                // console.log( "EVENT LAYER: FORM SUCCESS" );
                window.dataLayer.push( {
                    event: 'account_signup_email_verified',
                    site_language: window.app.data.locale
                } );
                break;
            case "confirmation-error":
                // console.log( "EVENT LAYER: FORM ERROR" );
                window.dataLayer.push( {
                    event: 'account_signup_email_not_verified',
                    site_language: window.app.data.locale
                } );
                break;
            case "check-email-verified":
            case "check-email-pending":
                // console.log( "EVENT LAYER: EMAIL ERROR" );
                window.dataLayer.push( {
                    event: 'signup_form_submission_completed',
                    site_language: window.app.data.locale
                } );
                break;
            case "download-wallpaper-desktop":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'button_click',
                        creative_title: 'desktop',
                        creative_type: 'button',
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            case "download-wallpaper-mobile":
                addDataLayerListener({
                    element,
                    event: 'click',
                    payload: {
                        event: 'button_click',
                        creative_title: 'mobile',
                        creative_type: 'button',
                        destination_url: element.getAttribute( 'href' ),
                        site_language: window.app.data.locale
                    }
                });
                break;
            default:
                // console.log( "Nothing to attach to data-layer event handler" );
        }
    } );
}

export { dataLayerEvents, autowireAnalytics };
